import isEmpty from "lodash.isempty";

function normalizeNavigation(navigation = []) {
  // Ensure navigation is an array (defensive check)
  // Prevents .reduce() and .map() errors when data is malformed
  if (!Array.isArray(navigation)) {
    return [];
  }

  // Use an object to collect children for each parent for O(1) access.
  const childrenMap = {};

  // First pass: Populate the childrenMap and collect the root pages.
  const rootPages = navigation.reduce((accu, currentPage) => {
    if (currentPage.parent) {
      const parentId = currentPage.parent.id;
      if (!childrenMap[parentId]) {
        childrenMap[parentId] = [];
      }
      childrenMap[parentId].push(currentPage);
    } else {
      const childrenOfPage =
        navigation.find((page) => page.parent?.id === currentPage.id) || {};
      const iconId = isEmpty(childrenOfPage.related)
        ? null
        : childrenOfPage.related[0]?.id;
      accu.push({
        ...currentPage,
        // Ensure children is always an array
        children: Array.isArray(childrenOfPage.children)
          ? childrenOfPage.children
          : [],
        iconId,
      });
    }
    return accu;
  }, []);

  // Second pass: Attach children to their respective parents.
  const rootPagesWithChildren = rootPages.map((page) => {
    const children = childrenMap[page.id];
    return children ? { ...page, children } : page;
  });

  return rootPagesWithChildren;
}

export default normalizeNavigation;
